import {Country} from '@mapit/common-utils/dist/types'

import es from '@/utils/preferences/es'
import pt from '@/utils/preferences/pt'

export default {
  [Country.Spain]: es,
  [Country.Portugal]: pt,
}
